import MyCustomLogoFull from './Waadoo.cloud.png';

export const LogoFull = () => {
  return (
    <img src={MyCustomLogoFull} style={{ height: 30, width: 'auto' }} alt="" />
  );
};
